<template>
  <div class="ms-combobox ms-editor remain-focus-when-enter" :class="[{'ms-validate': true}]">
    <div v-if="title && showTitle" class="combo-title flex">
      <div class="combo-title__text">{{ title }}</div>
    </div>
    <label v-if="label" class="label">{{ label }}</label>
    <div
      class="flex-row combo-box-input"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <div v-if="leftIcon" :class="['icon24 left-icon', leftIcon]"></div>
      <div
        class="ls-item list-item-text show-text-span"
        :class="numberShowItem == data.length ? 'max-height-combo' : ''"
        v-show="isShowTextSpan && showTextSpan"
        @click="handleClickSpan"
      >
        <div class="item-text" :title="internalText">
          {{ internalSelectedShowing?.map(x => x[displayField]).join('; ') }}
        </div>
        <input
          v-if="isFocusInput"
          ref="inputFocus"
          :title="internalText"
          class="input input-focus flex no-press input_seach_grid"
          :placeholder="placeholder"
          :class="{disabled: disabled}"
          :disabled="disabled"
          @focus="onInputFocus"
        />
      </div>
      <!-- TODO => Thêm các prop để show tooltip -->
      <div
        class="ls-item"
        :class="[
          formatType == $ms.constant.FormatType.ComboboxMultiple ? 'filter-grid-multiple' : '',
          numberShowItem == data.length ? 'max-height-combo' : '',
        ]"
        v-show="!isShowTextSpan"
      >
        <div
          v-if="!filterSeachGrid && !isShowTextSpan"
          class="item-selected d-flex"
          v-for="(item, index) in internalSelectedShowing"
          :key="index"
        >
          <!-- Nếu không khai báo columns => Lấy trực tiếp dữ liệu không cần thông qua column (nvthinh 6.12.2023) -->
          {{ columns.length > 0 ? item[displayField] : item?.dataField }}
          <div class="icon16 ic-multiply" @click="onItemClick(item)"></div>
        </div>
        <input
          ref="input"
          v-if="formatType == $ms.constant.FormatType.ComboboxMultiple && filterSeachGrid"
          :title="internalText"
          class="input flex no-press input_seach_grid"
          :placeholder="placeholder"
          :class="{disabled: disabled}"
          :disabled="disabled"
          @keydown.f3="quickSearchClick"
          @keydown.f9="showQuickAdd(false, true)"
          @blur="onBlur"
          @input="onInputSearchGrid"
        />
        <input
          v-else
          ref="input"
          :title="internalText"
          class="input flex no-press"
          :placeholder="placeholder"
          :class="{disabled: disabled}"
          :disabled="disabled"
          @keydown="onKeyDown"
          @keydown.f3="quickSearchClick"
          @keydown.f9="showQuickAdd(false, true)"
          @blur="onBlur"
          @input="onInput"
        />
      </div>

      <div
        v-if="quickAdd"
        class="quickAdd"
        :class="{hide: disabled}"
        @click="showQuickAdd"
        @keydown.enter="showQuickAdd"
      ></div>
      <div
        class="icon-combo--dropdown"
        :class="[
          {
            disabled: disabled,
            expand: expanded,
          },
          numberShowItem == data.length ? 'max-height-combo-icon' : '',
        ]"
        @click="triggerClick"
      ></div>
    </div>
    <div v-if="errorMessage && isShowText && !isGridEditor" class="error-text">
      {{ errorMessage }}
    </div>
    <ms-combo-box-dropdown
      v-if="expanded"
      ref="dropdownPanel"
      :topx="dropdownTopx"
      :leftx="dropdownLeftx"
      :max-widthx="dropdownMaxWidthx"
      :min-widthx="dropdownMinWidthx"
      :columnx="columns"
      :combo-type="comboType"
      :scroll-top="dropdownScrollTop"
      :loading="loading"
      :quick-add="quickAdd"
      :quick-search="quickSearch"
      :is-check-multiple="true"
      :has-header-dropdown="hasHeaderDropdown"
      :row-count="internalDataSource.length"
      @scrollend="dropdownScrollEnd"
      @update:scroll-top="doBeforeUnmount"
      @add-new="showQuickAdd"
    >
      <ms-combo-box-item
        v-for="(item, index) in internalDataSource"
        :key="item[valueField]"
        :combo-type="comboType"
        :item="item"
        :is-selected="cacheSelected.has(item[valueField])"
        :columnx="columns"
        :value-field="valueField"
        :is-check-multiple="true"
        :display-field="displayField"
        :class="{'ms-combobox-item--highlight': typeAheadPointer === index}"
        @mousedown="onItemClick(item, $event, index)"
      ></ms-combo-box-item>
      <template #quickSearch>
        <div
          v-if="quickSearch"
          class="quickSearch"
          :class="{hide: disabled}"
          @click="quickSearchClick"
          @keydown.enter="quickSearchClick"
        >
          <div class="button icon24 quick-search ic-zoom-out-blue" v-tooltip="'Mở rộng'"></div>
          <!-- <div class="txt-quick-search">Mở rộng</div> -->
        </div>
      </template>
    </ms-combo-box-dropdown>
  </div>
</template>
<script>
import {watch, ref, nextTick, getCurrentInstance, onMounted, onBeforeUnmount, computed, onBeforeMount} from 'vue';

import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import commonFn from '@/commons/commonFunction.js';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import popupUtil from '@/commons/popupUtil.js';
import componentUtil from '@/commons/componentUtil';
import {filter} from '@/mixins/common/filter';
import {MSConstant} from '@/commons/wildcards';
import _ from 'lodash';
export default {
  components: {
    MsComboBoxDropdown,
    MsComboBoxItem,
  },
  mixins: [filter],
  extends: msBaseComponent,
  props: {
    modelValue: {},
    customTooltip: {
      default: null,
      type: [Object],
    },
    // Index của combo điều kiện lọc tìm kiếm chứng từ chỉ riêng cho màn tìm kiếm chứng từ
    indexCombo: {
      default: null,
      type: Number,
    },

    placeholder: {
      default: null,
      type: [Number, String],
    },
    maxItemsDisplay: {
      default: 5,
      type: Number,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    /**
     * Trường làm value
     * CreatedBy LTDAT 15.06.2020
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường làm text display
     * CreatedBy LTDAT 15.06.2020
     */
    displayField: {
      type: String,
      default: null,
    },
    // Dữ liệu của combobox
    data: {
      default: () => [],
      type: Array,
    },
    // Độ rộng của 1 item
    itemSize: {
      default: 32,
      type: Number,
    },
    // Chỉ nhận giá trị có trong danh sách
    forceSelection: {
      default: true,
      type: Boolean,
    },
    // Là combotree hay không
    isTree: {
      default: false,
      type: Boolean,
    },
    // Parent Field
    idProperty: {
      default: 'id',
      type: String,
    },
    // Field chứa parentID
    parentIdProperty: {
      default: 'parent_id',
      type: String,
    },
    // Không cho phép chọn trường là cha
    notSelectionParent: {
      default: false,
      type: Boolean,
    },
    // Độ rông của dropdown tính bằng px
    dropdownWidth: {
      default: null,
      type: [String, Number],
    },
    // Mode query lấy dữ liệu từ server hay client
    queryMode: {
      type: String,
      default: 'local',
    },
    remoteFilter: {
      type: Boolean,
      default: false,
    },
    // Gán giá trị text lúc ban đầu
    initText: {
      default: null,
      type: [Number, String],
    },
    // chỉ cho phép chọn không cho phép nhập text
    selectOnly: {
      default: false,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    display: {},
    mappingField: {
      default: null,
    },
    firstExpandLoad: {
      default: false,
      type: Boolean,
    },
    keyField: {
      // default: '__vKeyValue',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    leftIcon: {
      type: String,
    },
    /**
     * Câu hình quicksearch
     */
    quickSearch: {
      type: String,
    },
    /**
     * Dữ liệu truyền kèm quicksearch
     */
    quickSearchParam: {
      type: Object,
      default: null,
    },
    /**
     * Câu hình add
     */
    quickAdd: {
      type: String,
      default: null,
    },
    isShowText: {
      type: Boolean,
      default: true,
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    requestField: {
      type: String,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    /**
     * Danh sách các trường dữ liệu lấy về
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * custom lại tham số filter
     */
    buildFilter: {
      type: Function,
      default: null,
    },

    isReload: {
      type: Boolean,
      default: false,
    },
    /**
     * size paging
     */
    pageSize: {
      type: Number,
      default: 10,
    },
    /**
     * Giá trị bản ghi tất cả
     */
    selectAllValue: {
      type: [Number, String],
      default: -1,
    },
    /**
     * Text hiển thị tất cả
     */
    selectAllText: {
      type: String,
      default: null,
    },
    /**
     * Có hiển thị bản ghi tất cả không
     */
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },
    // Xác định các rule validate
    // Mặc định của combo sẽ là force select
    rules: {
      default: null,
      type: Array,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    label: {
      default: null,
      type: String,
    },
    selected: {
      default: null,
      type: Array,
    },
    hasHeaderDropdown: {
      type: Boolean,
      default: true,
    },
    isGridEditor: {
      type: Boolean,
      default: false,
    },
    /**
     * Tùy chọn có hiển thị giá trị <<Tất cả>> không
     */
    isShowSelectAllValue: {
      type: Boolean,
      default: false,
    },

    /**
     * Tùy chọn có hiển thị giá trị <<Tổng hợp>> hay không
     */
    isShowSelectSummaryValue: {
      type: Boolean,
      default: false,
    },
    /**
     * Type combo
     */
    formatType: {
      type: [Number, String],
      default: 16,
    },
    /**
     * Số item hiển thị lên màn hình
     */
    numberShowItem: {
      default: 5,
      type: [Number, String],
    },
    /**
     * Tùy chọn có nhập dữ liệu input có tiền kiếm load grid không
     */
    filterSeachGrid: {
      type: Boolean,
      default: false,
    },
    /**
     * Hiển thị text slected VD: '001;002' khi không focus input nếu focus thì hiển thị nhập bình thường
     */
    showTextSpan: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, {emit}) {
    const internalDataSource = ref([]);
    const input = ref({});
    const expanded = ref(false);
    const {proxy} = getCurrentInstance();
    const internalText = ref('');
    const loading = ref(false);
    const dropdownScrollTop = ref(0);
    let _filterData = null;
    const dropdownTopx = ref(0);
    const dropdownLeftx = ref(0);
    const comboType = ref(1);
    const dropdownPanel = ref({});
    const cacheSelected = ref(new Map());
    const typeAheadPointer = ref(0);
    const isShowTextSpan = ref(_.cloneDeep(props.showTextSpan)); // Biến hiển thi text span các dữ liệu selected
    const isFocusInput = ref(true); //Show input fake để thực hiện tab/shift tab vào control
    const isComboboxMulti = true; // Sử dụng để case kèo validate

    const rebuildSelectedItems = (cacheData = null) => {
      let splitInternalText = [];
      if (internalText && internalText.value != null) {
        splitInternalText = internalText.value.split(';').filter(x => x);
      }
      // const splitInternalText = internalText.value.split(';').filter(x => x);

      //Nếu queryMode = local thì lấy hết tất cả bản ghi vào source_data, nếu queryMode = remote thì lấy từng 20 bản ghi 1 lần và load thêm theo scroll
      var source_data = (props.queryMode == 'local' ? props.data : internalDataSource.value) || [];
      if (splitInternalText.length && splitInternalText.length > 0) {
        if (!source_data.length) {
          source_data = props.selected || [];
        }

        if (
          splitInternalText.length !== cacheSelected.value.size ||
          splitInternalText.some(x => ![...cacheSelected.value.values()]?.some(o => o[props.displayField] === x))
        ) {
          if (!cacheData) {
            cacheData = new Map();
            source_data.forEach(x => cacheData.set(x[props.displayField], x));
          }

          cacheSelected.value.clear();
          splitInternalText.forEach(text => {
            if (cacheData.has(text)) {
              const item = cacheData.get(text);
              cacheSelected.value.set(item[props.valueField], item);
            }
          });
        }
      } else {
        //  NXHung 15.05.2024 bổ sung case nếu internalText trống thì sẽ clear các giá trị đã từng được selected
        cacheSelected.value.clear();
      }
    };

    /**
     * Thực hiện tab vào input
     */
    const onInputFocus = () => {
      proxy.isFocusInput = false;
      proxy.isShowTextSpan = false;
      nextTick(() => {
        proxy.$refs.input.focus();
      });
    };
    /**
     * Click vào icon xổ xuống
     */
    const triggerClick = e => {
      const me = proxy;
      const expand = expanded.value;
      // disable thì không làm gì
      if (me.disabled) {
        return;
      }

      if (!expand) {
        // TODO => Query internal
        query();
        changeDropdownPosition();
      }

      expanded.value = !expand;
      nextTick(() => {
        adjustScroll();
      });

      // focus input
      input.value.focus();
      if (proxy.showTextSpan) {
        proxy.isShowTextSpan = false;
        nextTick(() => {
          input.value.focus();
        });
      }
    };

    /**
     * Thực hiện focus input
     */
    const handleClickSpan = () => {
      if (proxy.showTextSpan && proxy.isShowTextSpan) {
        proxy.isShowTextSpan = false;
        nextTick(() => {
          proxy.$refs.input.focus();
        });
      }
    };

    /**
     * Thay đổi position khi mở dropdown
     */
    const changeDropdownPosition = () => {
      const me = proxy;
      let comboEl = me.$el;
      if (comboEl) {
        comboEl = comboEl.getElementsByClassName('combo-box-input')[0];
      }

      if (comboEl) {
        const comboElRect = comboEl.getBoundingClientRect();

        me.dropdownLeftx = comboElRect.left;
        me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
        me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth ? me.dropdownWidth : comboElRect.width;

        let position;
        /** Nếu đã hiện dropdown thì set position theo dropdown */
        if (me.$refs.dropdownPanel && !me.internalDataSource.length) {
          position = componentUtil.getPosition(comboEl, me.$refs.dropdownPanel.$el);
        } else {
          /** Nếu chưa hiện thì set theo  */
          const maxItemsDisplay = me.maxItemsDisplay + 1;
          let height = 0;

          /** Xử lý khi đã có dữ liệu (Ẩn loading) */
          /** Đếm số dòng */
          const rowCount = Math.min(maxItemsDisplay, me.internalDataSource.length + (me.columns?.length > 0 ? 1 : 0));
          /**
           * Tính height theo số dòng
           * Do có border nên + 2px
           */
          height = (me.itemSize + 2) * rowCount + 9;
          /** Do max height là 200px nên khi thay đổi css maxHeight thì sửa code */
          height > 200 && (height = 200);

          /** Lấy position theo dom ảo do chưa hiện dropdown */
          position = componentUtil.getPosition(
            comboEl,
            document.createElement('div'),
            {},
            {maxWidth: me.dropdownMaxWidthx, maxHeight: height},
          );
        }

        /** Set position */
        me.dropdownBottomx = position.bottom || 0;
        me.dropdownLeftx = position.left;
        me.dropdownTopx = position.top;
      }
    };

    const query = () => {
      switch (props.queryMode) {
        case 'local':
          const take = internalDataSource.value.length;
          localQuery(take);
          break;
        case 'remote':
          remoteQuery();
          break;
        default:
          break;
      }
    };

    const onEsc = e => {
      const me = proxy;

      // ẩn dropdown và stop event nếu đang expand
      if (me.expanded) {
        expanded.value = false;
        e.preventDefault();
        e.cancel = true;
      }
    };

    const onKeyDown = e => {
      if (e.keyCode !== proxy.$ms.constant.KeyCode.Tab) {
        // e.preventDefault();
        // e.stopPropagation();
      }
      switch (e.keyCode) {
        case proxy.$ms.constant.KeyCode.Enter:
          if (typeAheadPointer.value >= 0 && typeAheadPointer.value < internalDataSource.value.length) {
            onItemClick(internalDataSource.value[typeAheadPointer.value], e);
          }

          proxy.$nextTick(() => {
            expanded.value = false;
          });
          return;
        case proxy.$ms.constant.KeyCode.Up:
          if (typeAheadPointer.value === 0) return;
          typeAheadPointer.value -= 1;
          adjustScroll();
          return;

        case proxy.$ms.constant.KeyCode.Down:
          if (!expanded.value) {
            typeAheadPointer.value = 0;
            triggerClick();
          } else {
            if (
              lastRequestParam &&
              lastRequestParam.end &&
              internalDataSource.value.length === typeAheadPointer.value + 1
            ) {
            } else {
              typeAheadPointer.value += 1;
              adjustScroll();
            }
          }
          return;
        // pckien 12.06.2023 Đóng combo khi nhấn Tab
        case proxy.$ms.constant.KeyCode.Tab:
          expanded.value ? triggerClick() : null;
          // nếu có props chỉ show text khi outfocus và đang thực hiện focus chỉnh sửa (isShowTextSpan = false)=> tab ra ngoài hiển thị text, đóng chỉnh sửa
          if (proxy.showTextSpan && !proxy.isShowTextSpan) {
            proxy.isShowTextSpan = true;
            setTimeout(() => {
              proxy.isFocusInput = true;
            }, 0);
          }
          break;
        case proxy.$ms.constant.KeyCode.ESC:
          onEsc(e);
          break;
        case proxy.$ms.constant.KeyCode.Backspace:
          onDeleteItemByBackspace();
          break;
      }
      emit(proxy.$ms.constant.CustomEvent.MsKeydown, e);
    };

    /**
     * Bổ sung thêm hàm xóa các item đã chọn
     * pntoan 12.12.2023
     */
    const onDeleteItemByBackspace = () => {
      if (!proxy.$refs.input.value) {
        // Lấy ra item cuối cùng để xóa
        const lastItem = [...cacheSelected.value][cacheSelected.value.size - 1];
        if (lastItem) {
          // lấy ra key của item cuối
          const lastItemKey = lastItem[0];
          const lastItemValue = lastItem[1][proxy.displayField];
          if (lastItemKey != null && lastItemKey != undefined) {
            // Xóa selected trong droplist
            cacheSelected.value.delete(lastItemKey);
            // Xóa trong text hiển thị
            internalSelected.value.pop();
            // lấy giá trị vừa xóa và bỏ đi 1 ký tự cuối
            proxy.$refs.input.value = lastItemValue.substring(0, lastItemValue.length);
            internalText.value = buildText();
            // update lại text hiển thị sau khi xóa đi
            emit('update:modelValue', internalSelected.value.map(x => x[proxy.displayField]).join(';'));
          }
        }
      }
    };

    const getScroller = () => {
      if (expanded.value) {
        const dd = dropdownPanel.value;
        if (dd && dd.$el && typeof dd.$el.querySelector === 'function') {
          return dd.$el.querySelector('.scroller-overlay');
        }
      }
      return null;
    };

    const adjustScroll = () => {
      const row = dropdownPanel.value?.$el.querySelector('.combobox-item');
      if (row) {
        const rowHeight = row.getBoundingClientRect().height;
        const scroller = getScroller();
        if (scroller) {
          // scroller.scrollToItem(typeAheadPointer, true);
          scroller.scrollTop = Number.parseInt(rowHeight - 0.5) * typeAheadPointer.value;
        }
      }
    };

    // Scroll to top
    const scrollToTop = () => {
      const scroller = getScroller();
      if (scroller) {
        scroller.scrollTop = 0;
      }
    };

    /**
     * Query data có sẵn ở local
     */
    const localQuery = skip => {
      const usedData = _filterData ? _filterData : props.data;
      if (!lastRequestParam || !lastRequestParam.end) {
        const payload = {};
        payload.skip = skip;
        payload.take = props.pageSize;
        payload.pageAppend = true;

        const start = payload.skip;
        const count = Math.min(usedData.length, payload.take + start);
        const isEnd = count !== 0 ? count === start : false;

        if (!isEnd) {
          for (let i = payload.skip; i < count; i++) {
            internalDataSource.value.push(usedData[i]);
          }
        } else {
          payload.end = true;
        }
        lastRequestParam = payload;

        // rebuildSelectedItems();
      }
    };

    /**
     * Khởi tạo data
     */
    const initData = value => {
      let me = proxy,
        cacheData = null;
      // Xử lý dữ liệu, bổ sung thêm các giá trị <<Tất cả>> và <<Tổng hợp>>

      if (me.data && me.data.length > 0 && (me.isShowSelectAllValue || me.isShowSelectSummaryValue)) {
        // Check nếu hiển thị thì mới thực hiện xử lý
        // Thực hiện lấy về danh sách các prop cấu hình của columns
        if (me.columns && me.columns.length > 0) {
          var columnProps = [];
          me.columns.forEach(item => {
            columnProps.push(item.dataField);
          });
          // Mặc định cấu hình hiển thị sẽ là <<Tất cả>> - Tất cả, nên sẽ mặc định tìm theo giá trị đầu tiên của list prop
          if (columnProps.length > 0) {
            // Xử lý thêm mới giá trị chọn tất cả
            if (me.isShowSelectAllValue) {
              var selectAllValue = me.data.find(x => x[columnProps[0]] == MSConstant.SpecialValue.All);
              if (!selectAllValue) {
                me.data.unshift({});
                for (let index = 0; index < columnProps.length; index++) {
                  if (index == 0) {
                    // Mặc định thêm giá trị <<Tất cả>> vào đầu dòng
                    me.data[0][columnProps[index]] = MSConstant.SpecialValue.All;
                  } else {
                    me.data[0][columnProps[index]] = MSConstant.SpecialValue.AllText;
                  }
                }
                if (me.keyField != '' && typeof me.keyField != 'undefined') {
                  // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                  me.data[0][me.keyField] = MSConstant.SpecialValue.AllGuid;
                }
              }
            }
            // Xử lý thêm mới giá trị Tổng hợp
            if (me.isShowSelectSummaryValue) {
              var selectAllValue = me.data.find(x => x[columnProps[0]] == MSConstant.SpecialValue.Summary);
              if (!selectAllValue) {
                me.data.unshift({});
                for (let index = 0; index < columnProps.length; index++) {
                  if (index == 0) {
                    // Mặc định thêm giá trị <<Tổng hợp>> vào đầu dòng
                    me.data[0][columnProps[index]] = MSConstant.SpecialValue.Summary;
                  } else {
                    me.data[0][columnProps[index]] = MSConstant.SpecialValue.SummaryText;
                  }
                }
                if (me.keyField != '' && typeof me.keyField != 'undefined') {
                  // Trường hợp có cấu hình keyField, bổ sung thêm thông tin
                  me.data[0][me.keyField] = MSConstant.SpecialValue.SummaryGuid;
                }
              }
            }
          }
        }
      }

      if (props.queryMode === 'remote') {
        if (lastRequestParam && lastRequestParam.pageAppend) {
          cacheData = new Map();
          internalDataSource.value.concat(value).forEach(x => {
            if (!cacheData.has(x[props.valueField])) {
              cacheData.set(x[props.displayField], x);
            }
          });
          internalDataSource.value = [...cacheData.values()];
        } else {
          // Nếu có data mới sẽ clear cache do data thêm qua quick add sẽ được add trực tiếp vào list
          internalDataSource.value = value;
          cacheSelected.value.clear();
        }
        if (value.length < props.pageSize && lastRequestParam) {
          lastRequestParam.end = true;
        }
        // Rebuild lại các selected item nếu có
        rebuildSelectedItems(cacheData);
      } else {
        initLocalData();
      }
    };
    let lastRequestParam = null;

    /**
     * Khởi tạo lại local data khi có data thay đổi
     */
    const initLocalData = () => {
      //Thực hiện ộp toàn bộ data mới vào internal data theo thông số data đã lấy
      if (lastRequestParam) {
        let newData = [];
        if (props.data.length > internalDataSource.value.length) {
          for (let index = 0; index < internalDataSource.value.length; index++) {
            const element = props.data[index];
            newData.push(element);
          }
        } else {
          newData = [...props.data];
        }
        internalDataSource.value = newData;
        rebuildSelectedItems();
      }
    };

    /**
     * Query lên server
     */
    const remoteQuery = () => {
      if (!lastRequestParam || props.isReload) {
        const me = proxy;
        const payload = {};
        payload.skip = 0;
        payload.take = props.pageSize;
        payload.pageAppend = false;
        let columns = [props.displayField, props.valueField].concat(props.columns.map(x => x.dataField));

        columns = columns.distinctKey();
        payload.columns = columns.join(',');

        if (props.modelValue) {
          const modelValueSplit = props.modelValue.split(';');
          const selected = modelValueSplit.map(x => x);

          if (selected.length > 0) {
            Object.assign(payload, {
              selectedItem: JSON.stringify({[props.displayField]: selected}),
            });
          }
        }

        lastRequestParam = payload;
        emit('comboboxLoadData', payload);
      }
    };

    /**
     * Query thêm data nếu scroll xuống cuối
     */
    const dropdownScrollEnd = () => {
      if (props.queryMode === 'local') {
        query();
      } else {
        if (lastRequestParam && !lastRequestParam.end) {
          if (lastRequestParam.skip && lastRequestParam.skip === internalDataSource.value.length) {
            return;
          }

          const payload = lastRequestParam;
          payload.skip = internalDataSource.value.length;
          payload.pageAppend = true;
          emit('comboboxLoadData', payload);
        }
      }
    };
    /**
     * Tích chọn select hoặc ngừng select 1 item
     * pntoan 11.8.2023 Bổ sung thêm tích chọn tất cả
     */
    const effectItem = item => {
      const key = item[props.valueField];

      // Nếu mà trường chọn là tất cả
      if (key == MSConstant.SpecialValue.All || key == MSConstant.SpecialValue.Summary) {
        // Tích chon true thì xóa hết các combobox chọn con đi
        if (!cacheSelected.value.has(key)) {
          cacheSelected.value = new Map();
        }
        // tích false thì đi xuống luồng dưới xử lý tiếp rồi ( chỗ này ko làm j nữa )
      }
      // Nếu mà tích trường con thì bỏ tích trường tất cả đi
      else {
        // Bỏ đi giá trị tất cả
        internalSelected.value = internalSelected.value.filter(e => {
          return e[props.keyField] != MSConstant.SpecialValue.All;
        });
        // Xóa giá trị tất cả trong cacheSelected
        cacheSelected.value.delete(MSConstant.SpecialValue.All);

        // Bỏ đi giá trị tổng hợp
        internalSelected.value = internalSelected.value.filter(e => {
          return e[props.keyField] != MSConstant.SpecialValue.Summary;
        });
        // Xóa giá trị tổng trong cacheSelected
        cacheSelected.value.delete(MSConstant.SpecialValue.Summary);
      }
      // Kiêm tra xem có trường đấy rồi thì xóa đi ( tức là bỏ tích )
      if (cacheSelected.value.has(key)) {
        cacheSelected.value.delete(key);
        internalSelected.value.remove(item);
      }
      // Chưa có thì đang check nên thêm vào
      else {
        cacheSelected.value.set(key, item);
        internalSelected.value.push(item);
      }
    };

    /**
     * Build text hiển thị trên ô input
     */
    const buildText = () => {
      let rebuildText = '';
      const sizes = cacheSelected.value.size;
      let index = 0;
      cacheSelected.value.forEach((value, key) => {
        if (index === sizes - 1) {
          rebuildText += `${value[props.displayField]}`;
        } else {
          rebuildText += `${value[props.displayField]};`;
        }
        index++;
      });
      return rebuildText;
    };
    /**
     * Xử lý click vào item
     */
    const onItemClick = (item, event, index) => {
      proxy.$refs.input.focus();
      if (proxy.showTextSpan) {
        setTimeout(() => {
          proxy.isShowTextSpan = false;
          proxy.$refs.input.focus();
        }, 0);
      }
      effectItem(item);
      internalText.value = buildText();
      // TODO updateModel theo value field nếu có nhu cầu
      emit('update:modelValue', internalText.value);
      if (index !== undefined && index !== null) {
        typeAheadPointer.value = index;
      }

      const selected = [...cacheSelected.value.values()];
      // emit thêm sự kiện để bắt giá trị vừa chọn - tvhien 14.12.2022
      emit('onSelectedItem', item, selected);
      updateSelected(selected);
      nextTick(() => {
        setTimeout(() => {
          // nhập text search -> chọn -> auto xóa text search -> reset search
          // xổ list -> scroll end -> chọn -> dropdownlist ko bị scroll gì cả
          // xổ list -> scroll end -> nhập text search -> tự động scroll top -> chọn -> xóa text search -> reset text
          // + Nếu có nội dung search thì reset search đi
          if (input._value.value != '') {
            input._value.value = '';
            onSearchText('', event.keyCode && event.keyCode == proxy.$ms.constant.KeyCode.Enter);
          } else {
            input.value.focus();
          }
        }, 0);
      });
      cacheHeight = proxy.$el.clientHeight;
      nextTick(() => {
        if (proxy.$el.clientHeight !== cacheHeight) {
          changeDropdownPosition();
        }
      });
    };

    let cacheHeight = 0;
    const internalSelected = ref([]);
    const internalSelectedShowing = computed(() => internalSelected.value.slice(-proxy.numberShowItem));
    const updateSelected = selected => {
      emit('update:selected', selected, proxy.indexCombo);
      internalSelected.value = selected;
    };

    /**
     * Xử lý click ra ngoài
     * VDDONG 21/09/2023: Sửa lỗi click vào label không đóng combobox
     */
    const clickOutSide = e => {
      const me = proxy;
      if (
        !e.target.classList.contains('ic-multiply') &&
        (!commonFn.hasParent(e.target, me.$el) ||
          (commonFn.hasParent(e.target, me.$el) && e.target.className == 'label')) &&
        (!expanded.value ||
          (dropdownPanel.value && dropdownPanel.value.$el && !commonFn.hasParent(e.target, dropdownPanel.value.$el)))
      ) {
        expanded.value = false;
        // nếu có props chỉ hiển thị text khi out foccus => click ra ngoài show chỉ hiển thị text
        if (proxy.showTextSpan) {
          proxy.isFocusInput = true;
          proxy.isShowTextSpan = true;
        }
      }
    };

    const {errorMessage, handlerValidateCombobox, getTitleError, clearValidate} = useValidateControl({
      props,
    });
    const validate = () => {
      if (!props.isGridEditor) {
        return handlerValidateCombobox();
      }
      return '';
    };

    /**
     * Call back gọi từ form quick add, search
     */
    const callbackAddData = (data, type) => {
      const fullData = props.queryMode === 'remote' ? internalDataSource.value : props.data;
      const findValidData = arr => {
        switch (type) {
          case 'quickSearch':
            cacheSelected.value.clear();
            return arr.filter(item => {
              let cacheItem = item;
              cacheSelected.value.set(item[props.valueField], item);
              const existed = fullData.find(x => x[props.valueField] === item[props.valueField]);

              if (existed) {
                cacheItem = existed;
              }

              cacheSelected.value.set(cacheItem[props.valueField], item);
              return !existed;
            });
          // Default sẽ vào quick add do quick add dùng các form danh mục đã có
          default:
            return arr.filter(item => {
              const existed = fullData.find(x => x[props.valueField] === item[props.valueField]);

              if (!cacheSelected.value.has(item[props.valueField])) {
                cacheSelected.value.set(item[props.valueField], item);
              }

              if (existed) {
                return false;
              }
              return true;
            });
        }
      };
      if (Array.isArray(data)) {
        internalDataSource.value.unshift(...findValidData(data));
      } else {
        internalDataSource.value.unshift(...findValidData([data]));
      }

      internalText.value = buildText();
      emit('update:modelValue', internalText.value);

      // 30.08.2022 TPNam : Sửa thêm update seleted
      const selected = [...cacheSelected.value.values()];
      updateSelected(selected);
      // Trỏ scroll về thằng đầu tiên
      typeAheadPointer.value = 0;

      //VDDONG 21/06/2023: Trỏ con trỏ về lại input show popup quickAdd
      if (proxy.$refs.input) {
        setTimeout(() => {
          proxy.$refs.input.focus();
        }, 100);
      }
    };

    /**
     * Click vào icon quick add
     */
    const showQuickAdd = () => {
      const me = proxy;
      // Thực hiện query luôn lần đầu để chạy data select
      if (props.queryMode === 'remote') {
        query();
      }
      if (!me.loading) {
        if (!me.quickAdd) {
          return;
        }
        expanded.value = false;
        const param = {...(me.quickSearchParam || {})};
        param.mode = me.$ms.constant.FormState.Add;
        if (me.internalText) {
          param.quickAddText = me.internalText;
        }

        // Modified By NXCHIEN 01.06.2022 Sửa lại do base xử lý check options.submit
        param.options = {
          submit: callbackAddData,
          type: 'quickAdd',
        };

        // TODO => show popup quick add ở đây
        popupUtil.show(me.quickAdd, param);
      }
    };

    /**
     * Click vào icon quicksearch
     */
    const quickSearchClick = e => {
      const me = proxy;
      if (me.quickSearch) {
        if (me.disabled) {
          return;
        }
        me.expanded = false;
        const param = {...(me.quickSearchParam || {})};
        popupUtil.show(
          me.quickSearch,
          Object.assign(param, {
            /**
             * Sự kiện callback khi chọn item từ form tìm nhanh
             * Modified By NXCHIEN 01.06.2022 Sửa lại do base xử lý check options.submit
             */
            options: {
              submit: callbackAddData,
              type: 'quickSearch',
            },
            selected: props.modelValue,
            close: function () {
              me.$refs.input.focus();
            },
            // Đáp ứng danh mục cache
            data: me._allData,
            columns: me.columns,
            requestParam: lastRequestParam,
            multiple: true,
          }),
        );
      }
    };
    // Hook
    onMounted(() => {
      document.addEventListener('click', clickOutSide);
      watch(
        () => proxy.internalDataSource,
        () => {
          changeDropdownPosition();
        },
      );

      // edit: nmduc1 Load dữ liệu khi mới khởi tạo để có dữ liệu khi validate lúc cất
      if (props.queryMode === 'local') {
        localQuery(0);
      }

      proxy.hideWhenScroll();
    });
    onBeforeUnmount(() => {
      const me = proxy;
      expanded.value = false;
      if (dropdownPanel.value && dropdownPanel.value.$el) {
        dropdownPanel.value.$el.remove();
      }
      document.removeEventListener('click', clickOutSide);
    });

    // Sự kiện ẩn menu dropdown item đi
    const doBeforeUnmount = scrollTop => {
      emit('doBeforeUnmount');
    };

    const imediate = props.queryMode === 'remote' ? true : false;
    watch(
      () => props.data,
      (value, oldValue) => {
        if (Array.isArray(value)) {
          initData(value);
        }
      },
      {immediate: imediate},
    );

    watch(
      () => props.modelValue,
      (value, oldValue) => {
        //  NXHung 15.05.2024 thay đổi điều kiện check với undefined và null, case thêm trường hợp nếu value == '' thì thực hiện update giá trị selected thành mảng rỗng
        if (value !== undefined && value !== null && value !== internalText.value) {
          internalText.value = value;
          rebuildSelectedItems();
          if (value == '') {
            updateSelected([]);
          } else {
            updateSelected([...cacheSelected.value.values()]);
          }
        }
      },
      {immediate: true},
    );

    onBeforeMount(() => {
      const me = proxy;
      if (me.isTree) {
        me.comboType = 3;
      } else if (me.columns && me.columns.length !== 0) {
        me.comboType = 2;
      } else {
        me.comboType = 1;
      }
    });

    const getMetaData = () => {
      return JSON.parse(JSON.stringify([...cacheSelected.value.values()]));
    };

    const getValue = () => {
      return internalText.value;
    };

    /**
     * Tìm item theo text truyền vào
     * HTHIEP 01.07.2022
     */
    const findItemByText = queryText => {
      if (!queryText || !proxy.internalDataSource || proxy.internalDataSource.length === 0) {
        return false;
      }

      const arr = queryText.split(';');
      const rs = [];
      let items = [];
      const invalid = arr.some(txt => {
        let items = proxy.internalDataSource.filter(item => item[proxy.displayField] == txt);

        // Nếu mà không có giá trị thì có thêm 1 trường hợp là đang chọn ở combobox chọn nhiều dẫn đến là list source đang giới hạn ở những dữ liệu search
        // -> khi check những giá trị trước đó ng dùng đã chọn thì lại không có trong danh sách search -> báo lỗi không tồn tại -> sai
        // Giải pháp là check trên toàn bộ dữ liệu của combo
        if (items?.length == 0) {
          items = proxy.data?.filter(item => item[proxy.displayField] == txt);
        }

        rs.append(items);
        return !items.length;
      });

      return !invalid && rs;
    };

    /**
     * Ẩn combo khi scroll
     * @author nnnam - 4/10/2022
     */
    function hideWhenScroll() {
      const me = this;
      me.parentNodes = [];

      let pr = me.$el.parentNode;
      while (pr instanceof Element) {
        const style = getComputedStyle(pr);
        if (style && (style.overflow == 'auto' || style.overflowX == 'auto' || style.overflowY == 'auto')) {
          me.parentNodes.push(pr);
          pr.addEventListener('scroll', me.collapse);
        }
        pr = pr.parentNode;
      }
    }
    let timeout = 0;
    const onInput = e => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        // Nếu không phải là combo bên điều kiện tìm kiếm chứng từ thì tìm kiếm như thường
        if (proxy.indexCombo === null) {
          onSearchText(e.target.value);
        } else {
          //   TH là combo bên điều kiện tìm kiếm chứng từ thì phải expand combo thì mới tìm kiếm
          if (proxy.expanded == true) {
            onSearchText(e.target.value);
          }
          // Nếu combo chưa chọn giá trị nào thì mới emit sự kiện này ra ngoài để cập nhật filter cho tìm kiếm chứng từ còn nếu có rồi thì text khi nhập này không ảnh hưởng
          if (!internalText.value) {
            emit('search-text', e.target.value, proxy.indexCombo); // emit search-text ra ngoài để update cho model riêng cho màn tìm kiếm chứng từ
          }
        }
      }, 200);
    };

    /**
     * Nhập dữ liệu tìm kiếm grid
     * nnninh 06/12/2023
     */
    const onInputSearchGrid = e => {
      let valInputSearch = e.target.value.trim();

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (
          valInputSearch != null &&
          valInputSearch != '' &&
          proxy.internalSelected.length > 0 &&
          proxy.expanded == false
        ) {
          proxy.reset(false);
        }
        // Thêm tìm kiếm combo nếu có hiện dropdown item
        // nnninh 08/12/2023
        if (proxy.expanded) {
          onSearchText(e.target.value);
        }

        if (proxy.filterSeachGrid == true) {
          emit('filterGrid', valInputSearch);
        } else {
          onSearchText(e.target.value);
        }
      }, 500);
    };

    const onSearchText = (searchText, stopExpand) => {
      searchText = searchText.trim();
      switch (props.queryMode) {
        case 'remote':
          onSearchRemote(searchText, stopExpand);
          break;
        case 'local':
          onSearchLocal(searchText, stopExpand);
          break;
      }

      // Scroll to top
      scrollToTop();
    };

    const onSearchLocal = (searchText, stopExpand) => {
      if (!stopExpand) {
        expanded.value = true;
      }

      internalDataSource.value = [];
      if (searchText === '') {
        _filterData = null;
      } else {
        const data = filterData(searchText);
        _filterData = data;

        if (data.length < typeAheadPointer.value) {
          typeAheadPointer.value = 0;
        }
      }
      lastRequestParam = null;

      localQuery(0);
    };

    /**
     * Ẩn combo
     * ndhieu3 12.12.2023
     */
    const collapse = () => {
      const me = proxy;
      me.$nextTick(() => {
        me.expanded = false;
      });
    };
    /**
     * Bổ sung thêm tìm kiếm đối với mode remote
     * pntoan 12.12.2023
     */
    const onSearchRemote = (searchText, stopExpand) => {
      if (!stopExpand) {
        expanded.value = true;
      }

      internalDataSource.value = [];
      if (searchText === '') {
        _filterData = null;
      } else {
        const data = filterData(searchText);
        _filterData = data;

        if (data.length < typeAheadPointer.value) {
          typeAheadPointer.value = 0;
        }
      }
      lastRequestParam = null;

      localQuery(0);
    };

    const filterData = queryString => {
      const me = proxy;
      let matchItem = [];

      if (queryString) {
        props.data?.forEach(item => {
          let valid = false;
          for (const f in filterFields.value) {
            const value = item[f];
            const test = me.testFilter(filterFields.value[f], value, queryString);
            if (test) {
              valid = true;
              break;
            }
          }
          if (valid) {
            matchItem.push(item);
          }
        });
      } else {
        matchItem = props.data;
      }
      return matchItem;
    };

    /**
     * @modified nvthinh 6.12.2023: gán me = proxy thay cho this => tránh chết chương trình
     */
    const getFilterField = () => {
      const filter = {};
      const me = proxy;
      const columns = props.columns;
      if (columns && columns.length > 0) {
        for (let i = 0; i < columns.length; i++) {
          const col = columns[i];
          if (!col.filterOperator) {
            filter[col.dataField] = me.$ms.constant.FilterOperator.Contains;
          }
          if (col.dataField && col.filterOperator) {
            filter[col.dataField] = col.filterOperator;
          }
        }
      } else {
        filter[me.displayField] = me.$ms.constant.FilterOperator.Contains;
      }
      return filter;
    };

    const filterFields = ref(getFilterField());
    /**
     * Reset giá trị combobox
     * nnninh 05/12/2023
     */
    const reset = (clearInput = true) => {
      proxy.cacheSelected.clear();
      proxy.internalSelected = [];
      if (clearInput) {
        input._value.value = null;
      }
      proxy.internalText = null;

      emit('update:modelValue', internalText.value);
    };

    return {
      internalDataSource,
      query,
      onEsc,
      expanded,
      triggerClick,
      input,
      dropdownLeftx,
      dropdownTopx,
      internalText,
      loading,
      dropdownScrollEnd,
      comboType,
      dropdownScrollTop,
      validate,
      getTitleError,
      clearValidate,
      errorMessage,
      onItemClick,
      dropdownPanel,
      showQuickAdd,
      quickSearchClick,
      typeAheadPointer,
      onKeyDown,
      getMetaData,
      getValue,
      findItemByText,
      effectItem,
      buildText,
      hideWhenScroll,
      doBeforeUnmount,
      internalSelected,
      cacheSelected,
      internalSelectedShowing,
      onInput,
      reset,
      onInputSearchGrid,
      collapse,
      isComboboxMulti,
      isShowTextSpan,
      handleClickSpan,
      onInputFocus,
      isFocusInput,
    };
  },

  methods: {
    onBlur(evt) {
      const me = this;
      me.validate();
      this.$emit('blur', evt);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCombobox.scss';
.ls-item {
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 4px;
  &.max-height-combo {
    max-height: 74px;
    overflow: auto;
    border-right: 1px solid #c1c4cc;
  }
  input {
    min-width: 50px;
  }
  .input-focus {
    padding: 0;
    height: 0;
  }
  .item-selected {
    height: 24px;
    background: $button-primary-outline-hover-bg;
    margin-right: 4px;
    padding: 2px 6px;
    align-self: center;
    border-radius: 10px;

    .ic-multiply {
      margin-left: 3px;
    }
  }
}
.max-height-combo-icon {
  border-left: none;
}
.filter-grid-multiple {
  flex-wrap: nowrap;
  padding-left: 0;
  .list-item-selected-multiple {
    display: flex;
    .item-selected {
      font-weight: 500;
    }
  }
}
</style>
